<template>
    <div id="resultscontainer">
        <div v-if="(mergedConfig.resultstitle && mergedConfig.resultstitle.length) || mergedConfig.showresultslimit" class="resultshead">
            <v-row justify="space-between">
                <h1 v-if="mergedConfig.resultstitle && mergedConfig.resultstitle.length" v-html="mergedConfig.resultstitle"></h1>
                <div></div>
                <div v-if="mergedConfig.showresultslimit">
                    <v-text-field name="resultscount" :model="resultslimit" :value="resultslimit" label="Results Limit" @change="setLimit($event)" >
                    </v-text-field>
                </div>
            </v-row>
        </div>

        <ReportResultsChart v-if="!mergedConfig.hidechart && resultsSet" :resultsSet="resultsSet" :showConfig="showConfig" />

        <div  v-if="!mergedConfig.hideresultslist && reports_checkstatus.reportResults" style="margin-bottom:16px;" id="resultstablecontainer">
            <div v-if="mergedConfig.resultstabletitle && mergedConfig.resultstabletitle.length" class="cardtitle" v-html="mergedConfig.resultstabletitle"></div>
            <v-data-table
                v-if="!mergedConfig.showresultstoggle || displaytable"
                :headers="resultsheaders"
                :items="reports_checkstatus.reportResults"
                :items-per-page="10"
                class="elevation-1"
            >
                <template v-slot:item.su="{ item }">
                    <v-chip :color="item.su ? '#366836' : '#f03d15'" style="color:white">{{ item.su ? "PASS" : "FAIL" }}</v-chip>
                </template>
                <template v-slot:item.l="{ item }">
                    {{ item.l | filterLocations }}
                </template>
            </v-data-table>
            <div v-if="mergedConfig.showresultstoggle">
                <v-btn small @click="displaytable = !displaytable">{{ displaytable ? "Hide Results" : "Show Results" }}</v-btn>
            </div>
        </div>

    </div>
</template>


<script>
import { mapState, mapGetters } from "vuex";

import ReportResultsChart from "./Reports_Checkstatus_Results_Chart"
// import reportSchema from "../config/reports_checkstatus";

import { formatCapitalizeFirst } from "../lib/filter";
// import { parse as date_parse, format as date_format } from "date-fns";

export default {
    name: "ReportResults",
    props: {
        runpolling: {
            type: Boolean,
            default: false
        },
        reportid: {
            type: String
        },
        showConfig: { type: Boolean }
    },
    components: { ReportResultsChart },
    data () {
        return {
            resultsSet: 0,
            resultslimit: (this.$route.params.limit - 0) || 300,
            displaytable: null,
            chartOptions: null
        }
    },
    computed: {
        ...mapState(["currentUser", "reports_checkstatus", "now"]),
        ...mapGetters("reports_checkstatus", ["mergedConfig"]),
        // mergedConfig: function () {
        //     let temp = Object.assign({}, this.reports_checkstatus.reportConfig.check);
        //     for(let k in temp){
        //         if(typeof temp[k] === "string" && !temp[k].length) delete temp[k];
        //     }
        //     return Object.assign({}, this.reports_checkstatus.reportConfig, temp);
        // },
        resultsheaders: function () {
            const defaults = { time: true, rt: true, sc: true, l: true, m: true, su: true };
            // let config = ( this.reports_checkstatus.reportConfig &&
            //         ( (this.reports_checkstatus.reportConfig.check && this.reports_checkstatus.reportConfig.check.showprops) ||
            //           (this.reports_checkstatus.reportConfig.showprops) )
            //     ) ||
            //     {};
            let fields = this.mergedConfig.resultstable || defaults;
            let headers = [];
            let su;
            // console.log("prepping resultsheaders from",fields);

            // Set the normal results fields
            for(let k in this.reports_checkstatus.resultsSchema){
                let entry;
                if(fields[k] === false || fields[k] === undefined || (typeof fields[k] === 'object' && !fields[k].show) ) continue;
                entry = (typeof fields[k] === "object") ? {...this.reports_checkstatus.resultsSchema[k], ...fields[k]} : this.reports_checkstatus.resultsSchema[k];
                if(entry.label) entry.text = entry.label;
                if(entry.value === "su"){
                    // su goes at the end of the row
                    su = entry;
                } else if(entry === true || entry.show){
                    headers.push(entry);
                }
            }
            // console.log(fields, this.reports_checkstatus.reportCheck);
            // set up results.f fields
            for(let k in fields){
                // console.log('defaults?', defaults);
                let entry;
                if(fields[k] === false || !fields[k].show ) continue;
                if(defaults[k] === undefined && this.reports_checkstatus.reportCheck && this.reports_checkstatus.reportCheck.fields && this.reports_checkstatus.reportCheck.fields[k]){
                    let label = (typeof fields[k] === "object") ? fields[k].label : false;
                    entry = {
                        text: label || formatCapitalizeFirst(this.reports_checkstatus.reportCheck.fields[k].name.split(".").pop()),
                        align: "end",
                        sortable: true,
                        value: "f."+k,
                        show: true
                    };
                    headers.push(entry);
                }
                // console.log('resultsheaders entry', k, entry, fields[k]);


                // if(entry.value === "su"){
                //     su = entry;
                // } else if(entry === true || entry.show){
                //     headers.push(entry);
                // }
            }

            // re-add su column if its there
            if(su) headers.push(su);
            // console.log('resultshaeders out', headers);
            return headers;
        }
    },
    watch: {
        runpolling: {
            immediate: true,
            handler(newVal, oldVal) {
                // console.log('runpolling handler in results', newVal, oldVal);
                if(newVal){
                    this.startPolling();
                } else {
                    this.stopPolling();
                }
            }
        }
    },
    methods: {
        startPolling: function (){
            // console.log('Results start polling', this.runpolling, this.reportid);
            // if(this.runpolling && this.reportid) this.loadResults();
            if(this.runpolling) this.loadResults();
        },
        stopPolling: function (){
            clearTimeout(this.$options.polling);
        },
        loadResults: function (params) {
            // console.log('mergedConfig at loadResults', this.mergedConfig);
            params = params || {
                reportid: this.reportid,
                limit: this.resultslimit
            };

            this.$store
                .dispatch("reports_checkstatus/getResults", params)
                .then(() => {
                    // console.log('results loaded');
                    setTimeout(() => {this.resultsSet = this.reports_checkstatus.reportResults.length}, 10);
                    clearTimeout(this.$options.polling);
                    this.$options.polling = setTimeout( this.startPolling, 60000);
                })
                .catch( () => {
                    clearTimeout(this.$options.polling);
                    this.$options.polling = setTimeout( this.startPolling, 60000);
                });
        },
        setLimit: function (limit) {
            if(limit - 0 == limit){
                this.resultslimit = limit;
                this.$router.push({ limit: limit });
                this.startPolling();
            }
        }
        // ,
        // chartResults: function () {
        //     let data = [
        //         (reportSchema[this.reports_checkstatus.reportCheck.type] && reportSchema[this.reports_checkstatus.reportCheck.type].labels) ||
        //         reportSchema.default.labels ||
        //         ["Time", "Response"]
        //     ];
        //     let dlength = (this.reports_checkstatus.reportResults && this.reports_checkstatus.reportResults.length);
        //     for(let i=0; i < dlength; i++ ){
        //         data[i+1] = [
        //             // date_format(date_parse(this.reports_checkstatus.reportResults[i].s), "YYYY-MM-DD HH:mm"),
        //             date_parse(this.reports_checkstatus.reportResults[i].s),
        //             this.reports_checkstatus.reportResults[i].rt,
        //             // this.reports_checkstatus.reportResults[i].su
        //         ];
        //     }
        //     // console.log('chartOptions', this.chartOptions);
        //     return data;
        // },
        // setChartConfig: function () {
        //     this.chartOptions = Object.assign({}, reportSchema.default.options);
        //     // console.log("setChartConfig", this.reports_checkstatus.reportCheck);
        //     if(
        //         this.reports_checkstatus && this.reports_checkstatus.reportCheck && this.reports_checkstatus.reportCheck.type &&
        //         reportSchema[this.reports_checkstatus.reportCheck.type]
        //     ){
        //         for(let key in reportSchema[this.reports_checkstatus.reportCheck.type].options){
        //             if(typeof reportSchema[this.reports_checkstatus.reportCheck.type].options[key] === "object"){
        //                 this.chartOptions[key] = Object.assign({}, this.chartOptions[key], reportSchema[this.reports_checkstatus.reportCheck.type].options[key]);
        //                 console.log("settting option", key, reportSchema[this.reports_checkstatus.reportCheck.type].options[key], this.chartOptions[key])
        //             } else {
        //                 this.chartOptions[key] = reportSchema[this.reports_checkstatus.reportCheck.type].options[key];
        //             }
        //         }
        //     }
        //     console.log("setChartConfig", this.chartOptions);
        // }
    },
    created () {
        // this.startPolling();
    },
    beforeDestroy: function () {
        this.stopPolling()
    },
    filters: {
        filterLocations: function (val) {
            return Object.values(val).join(", ").toUpperCase();
        }
    }
}
</script>

<style scoped>
.resultshead {
    /* max-height: 80px; */
    padding: 0 20px 0 18px;
    margin-top: 12px;
    margin-bottom: 0;
}
</style>